export default "__VITE_ASSET__b625ecef__"